"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMultiScalpingV1Parameters = void 0;
const types_1 = require("../types");
const isMultiScalpingV1Parameters = (x) => x.method === types_1.Method.MultiScalpingV1;
exports.isMultiScalpingV1Parameters = isMultiScalpingV1Parameters;
